import { formatDays } from './formatDays';
import { dayCount } from './revisionText';
import type { EnrolledBalanceDto } from './types';

// Display props for one balance tile. Built from an EnrolledBalanceDto via
// `balanceToTile`, or supplied directly (e.g. placeholder/mock tiles).
export type BalanceTileData = {
  key: string | number;
  label: string;
  color: string;
  icon: string;
  value: string;
  unit?: string;
  subtitle?: string;
};

// Maps an enrolled balance to tile display props. `unitLabel` tunes the caption
// ("days" on the home card, "days available" in the request drawer). Flexible
// (unlimited) policies always read "N days used" (current-year usage), ignoring
// `unitLabel`, so the home card and request drawer read identically. A value that
// displays as 1 reads the singular: "1 day", "1 day available", "1 day used".
export function balanceToTile(b: EnrolledBalanceDto, unitLabel = 'days'): BalanceTileData {
  const value = b.flexible ? formatDays(b.usedYtd) : formatDays(b.available);
  const unit = b.flexible ? 'days used' : unitLabel;
  return {
    key: b.categoryId,
    label: b.categoryName,
    color: b.color || '#14AE5C',
    icon: b.icon,
    value,
    unit: value === '1' ? unit.replace('days', 'day') : unit,
    subtitle:
      !b.flexible && Number(b.scheduled) > 0
        ? `${dayCount(Number(b.scheduled))} scheduled`
        : undefined,
  };
}
